export default "__VITE_ASSET__44408e2e__"